import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const SUBSCRIPTION_PRODUCTS_SUBSCRIPTION_PRODUCT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    // routes.add([
    //   {
    //     path: '/subscription-products',
    //     iconClass: 'fas fa-file-alt',
    //     name: '::Menu:SubscriptionProducts',
    //     layout: eLayoutType.application,
    //     requiredPolicy: 'Ldm.SubscriptionProducts',
    //   },
    // ]);
  };
}
